// extracted by mini-css-extract-plugin
export default {"countDown":"countDown_countDown__c6bK2"};